import script from "./OptimizedTooltipText.vue?vue&type=script&lang=ts&setup=true"
export * from "./OptimizedTooltipText.vue?vue&type=script&lang=ts&setup=true"

import "./OptimizedTooltipText.vue?vue&type=style&index=0&id=5c152460&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c152460"]])

export default __exports__